import localforage from "localforage";

export const appId = process.env.REACT_APP_APP_ID;


const initialTableConfigs = {
    jobs: {
        tableId: process.env.REACT_APP_TABLE_JOBS, // The tableId for the jobs table
        fetchFilter: "{11.EX.'Active'}", //Status is active
        fields: [
            { id: -1, label: "childrenUpdated", type: "boolean" },
            { id: 0, label: "locallyUpdatedAt", type: "number" },
            { id: 1, label: "dateCreated", type: "string" },
            { id: 2, label: "dateModified", type: "string" },
            { id: 3, label: "recordId", type: "number", inputType: "number" },
            { id: 4, label: "recordOwner", type: "object" },
            { id: 5, label: "lastModifiedBy", type: "object" },
            { id: 8, label: "jobName", type: "string" },
            { id: 11, label: "status", type: "string" },
            { id: 12, label: "location", type: "string" },
            { id: 34, label: "jobNumber", type: "key" },
            { id: 41, label: "customerName", type: "number"},
        ]
    },
    employees: {
        tableId: process.env.REACT_APP_TABLE_EMPLOYEES,
        fetchFilter: "{46.EX.'Active'}",
        fields: [
            { id: -1, label: "childrenUpdated", type: "boolean" },
            { id: 0, label: "locallyUpdatedAt", type: "number" },
            { id: 1, label: "dateCreated", type: "string" },
            { id: 2, label: "dateModified", type: "string" },
            { id: 3, label: "recordId", type: "key", inputType: "number" },
            { id: 4, label: "recordOwner", type: "object" },
            { id: 5, label: "lastModifiedBy", type: "object" },
            { id: 43, label: "name", type: "string" },
            { id: 50, label: "titles", type: "string" },
        ]
    },
    laborLineItems: {
        tableId: process.env.REACT_APP_TABLE_LABOR_LINE_ITEMS,
        fetchFilter: "{102.EX.'1'}",
        fields: [
            { id: 83, label: "tempId", sendAs: String, convertTo: Number, type: "number", editable: true },
            { id: -5, label: "postedToQuickbase", type: "boolean", editable: false },
            { id: -3, label: "relatedEmployeeTitles", type: "string", inputType: "text", formulaFunction: (record) => (record?.relatedEmployee_record?.titles)},
            { id: -1, label: "childrenUpdated", type: "boolean" },
            { id: 0, label: "locallyUpdatedAt", type: "number" },
            { id: 1, label: "dateCreated", type: "string" },
            { id: 2, label: "dateModified", type: "string" },
            { id: 3, label: "recordId", type: "key", inputType: "number" },
            { id: 4, label: "recordOwner", type: "object" },
            { id: 11, label: "relatedDailyFieldReport", type: "number", inputType: "number", editable: true, relTo: "dailyFieldReports" },
            { id: 23, label: "position", type: "string", editable: true, inputType: "text-multichoice", options: [
                "Operator",
                "Laborer",
                "Foreman",
                "Welder",
                "Helper"
            ] },
            { id: 37, label: "relatedEmployee", type: "number", editable: true, relTo: "employees", inputType: "relationship", filterFunction: (employee) => true },
            { id: 108, label: "hours", type: "number", editable: true, inputType: "currency" },
        ]
    },
    equipmentLineItems: {
        tableId: process.env.REACT_APP_TABLE_EQUIPMENT_LINE_ITEMS,
        fetchFilter: "{34.EX.'1'}",
        fields: [
            { id: 19, label: "tempId", sendAs: String, convertTo: Number, type: "number", editable: true },
            { id: -5, label: "postedToQuickbase", type: "boolean", editable: false },
            { id: -1, label: "childrenUpdated", type: "boolean" },
            { id: 0, label: "locallyUpdatedAt", type: "number" },
            { id: 1, label: "dateCreated", type: "string" },
            { id: 2, label: "dateModified", type: "string" },
            { id: 3, label: "recordId", type: "key", inputType: "number" },
            { id: 4, label: "recordOwner", type: "object" },
            { id: 5, label: "lastModifiedBy", type: "object" },
            { id: 6, label: "relatedDailyFieldReport", type: "number", editable: true, relTo: "dailyFieldReports" },
            { id: 38, label: "typeOfEquipment", type: "string", editable: true, inputType: "text" },
            { id: 39, label: "serialNumber", type: "string", editable: true, inputType: "text" },
        ]
    },
    dailyFieldReports: {
        tableId: process.env.REACT_APP_TABLE_DAILY_FIELD_REPORTS,
        fetchFilter: "{107.EX.'1'}",
        fields: [
            { id: 84, label: "tempId", sendAs: String, convertTo: Number, type: "number", editable: true },
            { id: -2, label: "submitted", type: "boolean" },
            { id: -1, label: "childrenUpdated", type: "boolean" },
            { id: 0, label: "locallyUpdatedAt", type: "number" },
            { id: 1, label: "dateCreated", type: "string" },
            { id: 2, label: "dateModified", type: "string" },
            { id: 3, label: "recordId", type: "key", inputType: "number" },
            { id: 4, label: "recordOwner", type: "object" },
            { id: 5, label: "lastModifiedBy", type: "object" },
            { id: 7, label: "street1", type: "string", editable: true },
            { id: 8, label: "street2", type: "string", editable: true },
            { id: 9, label: "city", type: "string", editable: true },
            { id: 10, label: "state", type: "string", editable: true, options: [
                "Alabama",
                "Alaska",
                "Arizona",
                "Arkansas",
                "California",
                "Colorado",
                "Connecticut",
                "Delaware",
                "District of Columbia",
                "Florida",
                "Georgia",
                "Hawaii",
                "Idaho",
                "Illinois",
                "Indiana",
                "Iowa",
                "Kansas",
                "Kentucky",
                "Louisiana",
                "Maine",
                "Maryland",
                "Massachusetts",
                "Michigan",
                "Minnesota",
                "Mississippi",
                "Missouri",
                "Montana",
                "Nebraska",
                "Nevada",
                "New Hampshire",
                "New Jersey",
                "New Mexico",
                "New York",
                "North Carolina",
                "North Dakota",
                "Ohio",
                "Oklahoma",
                "Oregon",
                "Pennsylvania",
                "Rhode Island",
                "South Carolina",
                "South Dakota",
                "Tennessee",
                "Texas",
                "Utah",
                "Vermont",
                "Virginia",
                "Washington",
                "West Virginia",
                "Wisconsin",
                "Wyoming"
            ] },
            { id: 11, label: "postalCode", type: "string", editable: true },
            { id: 12, label: "country", type: "string", editable: true },
            { id: 13, label: "date", sendAs: (string) => string+"T00:00:00", convertTo: (string) => {
                if(!string) return string;
                const date = new Date(string);
                return `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
            }, stringtype: "string", editable: true, inputType: "text" },
            { id: 15, label: "foremanName", type: "string", editable: true },
            { id: 16, label: "foremanSignature", type: "object", editable: true },
            { id: 17, label: "inspectorName", type: "string", editable: true },
            { id: 18, label: "inspectorSignature", type: "string", editable: true },
            { id: 23, label: "jobNumber", type: "string", editable: true, relTo: "jobs", inputType: "text" },
            { id: 32, label: "status", type: "string", editable: true },
            { id: 79, label: "notes", type: "string", editable: true, inputType: "text" },
        ]
    },
};


function buildOutConfigs(data) {
    // Initialize childTables for all tables
    Object.keys(data).forEach(tableName => {
        data[tableName].childTables = {};
        data[tableName].minTempId = 0;
        data[tableName].tableLastSynced = 100;
    });

    // Populate childTables based on relTo fields
    Object.keys(data).forEach(tableName => {
    
        const fields = data[tableName].fields;

        fields.forEach(field => {
            if (field.relTo) {
                const parentTable = field.relTo;
                // Add the current table and field as a child of the parent table
                data[parentTable].childTables[tableName] = field;
            }
        });
    });
    return data;
}

export const tableConfigs = buildOutConfigs(initialTableConfigs);

export const getLowestTempId = async (tableName, db) => {
    const {fields} = tableConfigs[tableName];
    const keyField = fields.find(field => field.type === 'key').label;
    const lowestInTable = await db[tableName].orderBy(keyField).first();
    const lowest = lowestInTable && lowestInTable[keyField] < 0 ? lowestInTable[keyField] : 0;
    return lowest
};
export async function initForage(db) {
    let tables = await localforage.getItem(`${appId}_tables`);
    let syncTables = Object.keys(tableConfigs);

    let syncMetadata = window.localStorage.getItem(`${appId}_metadata`);
    syncMetadata = syncMetadata ? JSON.parse(syncMetadata) : null;
    let metadata = await localforage.getItem(`${appId}_metadata`);

    window.localStorage.setItem(`${appId}_tables`, JSON.stringify(Object.keys(tableConfigs)));
    syncTables.forEach(async (tableName) => {
        let storedMinTempId = Number(window.localStorage.getItem(`${appId}_${tableName}_MinTempId`));
        if(!storedMinTempId) {
            const lowestIdInDexie = await getLowestTempId(tableName, db);
            window.localStorage.setItem(`${appId}_${tableName}_MinTempId`, String(lowestIdInDexie));
        }
    })
    if(!metadata) {
        localforage.setItem(`${appId}_metadata`,
            {lastSyncCheck: 100}
        )
    }

    if(!syncMetadata) {
        window.localStorage.setItem(`${appId}_metadata`,JSON.stringify(
            {lastSyncCheck: 100}
        ))
    }
    let finalTables = {};
    let promises = []
    if(!tables) {
        const newTables = {};
        Object.keys(tableConfigs).forEach(tableName => {
            const table = tableConfigs[tableName];
            let { fields } = table;
            fields = fields.map((field) => {
                const newField = {...field};
                delete newField.filterFunction;
                delete newField.formulaFunction;
                delete newField.sendAs;
                delete newField.convertTo;
                return newField;
            }) 
            const newTable = {...table, fields};
            delete newTable.childTables;
            newTables[tableName] = newTable;
        })
        
        // const newTables = {childTables, fetchFilter, fields, minTempId, tableId, tableLastSynced};
    
        finalTables = newTables;
    } else {
        const tableNames = Object.keys(tableConfigs);
        promises = tableNames.map(async tableName => {
            const configTable = tableConfigs[tableName];
            const forageTable = tables[tableName];
            let {tableId, fetchFilter, fields} = configTable;

            const newFields = fields.map((field) => {
                const newField = {...field};
                delete newField.filterFunction;
                delete newField.formulaFunction;
                delete newField.sendAs;
                delete newField.convertTo;
                return newField;
            }) 

            const firstMinTempId = forageTable?.minTempId ? forageTable?.minTempId : configTable?.minTempId;
            const lowestIdInDexie = await getLowestTempId(tableName, db);
            const minTempId = firstMinTempId < lowestIdInDexie ? firstMinTempId : lowestIdInDexie;
            const tableLastSynced = forageTable?.tableLastSynced ? forageTable?.tableLastSynced : configTable?.tableLastSynced;
            const newTable = {
                tableId,
                fetchFilter,
                fields: newFields,
                minTempId,
                tableLastSynced
            }
            finalTables[tableName] = newTable
        })
    
    }
    await Promise.all(promises);

    await localforage.setItem(`${appId}_tables`, finalTables)
}
